<template>
    <Loader wait-text="Loading User Profile Photo..." v-if="isLoading"/>
    <div v-else>
        <ImageUpload :image-src="src" @uploaded="handleFileUploaded" @removed="handleLogoRemoved"/>

        <SubmitButton type="submit" :loading="isSaving"
                      class="btn btn-primary"
                      name="Save Profile Photo"
                      @click="handleSave"/>
    </div>

</template>

<script>
import ImageUpload from "@/pages/user/AccountPanel/ImageUpload.vue";
import {useLoading} from "@/hooks/use-loading";
import {onMounted, ref} from "vue";
import {getProfilePhotoUrl, saveProfilePhoto} from "@/api/user";
import Loader from "@/components/Loader.vue";
import SubmitButton from "@/components/SubmitButton.vue";
import {showSuccessMessage} from "@/helpers/notify";

export default {
    name: "ProfilePhoto",
    components: {SubmitButton, Loader, ImageUpload},
    setup() {
        const LOGO_REMOVE = 0;
        const LOGO_UPLOAD = 1;
        const LOGO_NO_CHANGE = 2;

        const {isLoading, startLoading, stopLoading} = useLoading(true);

        const src = ref('');
        const photo = ref(null);
        const upload = ref(LOGO_NO_CHANGE);

        const isSaving = ref(false);

        const loadProfilePhoto = async () => {
            try {
                startLoading();
                src.value = (await getProfilePhotoUrl()).data.result;
            } catch (e) {
                console.error(e);
            } finally {
                stopLoading();
            }
        };

        const handleLogoRemoved = () => upload.value = LOGO_REMOVE;

        const handleFileUploaded = (file) => {
            photo.value = file;
            upload.value = LOGO_UPLOAD;
        }

        const handleSave = async () => {
            try {
                isSaving.value = true;

                await saveProfilePhoto({
                    photo: photo.value,
                    upload: upload.value
                });

                showSuccessMessage("Profile photo changes saved successfully.");
            } catch (e) {
                console.error(e);
            } finally {
                isSaving.value = false;
            }
        };

        onMounted(() => loadProfilePhoto());

        return {
            isLoading,
            isSaving,
            src,
            photo,
            handleLogoRemoved,
            handleFileUploaded,
            handleSave
        }
    }
}
</script>